// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vvvU","top":"styles_top__zppb6","left":"styles_left__358hn","description":"styles_description__1aLxI"};